import React from "react";
import { FormikTouched, FormikErrors } from "formik";
import Select, { PropsValue, OptionsOrGroups, ActionMeta } from "react-select";

interface OptionType {
  value: string;
  label: string;
}

interface SelectInputProps {
  label: string;
  id: string;
  name: string;
  options: OptionsOrGroups<OptionType, any>;
  value: PropsValue<OptionType>;
  onChange: (
    value: PropsValue<OptionType>,
    actionMeta: ActionMeta<OptionType>
  ) => void;
  onBlur: () => void;
  touched: FormikTouched<any>;
  error: FormikErrors<any>;
  width?: string;
  showLabel?: boolean;
  placeholder?: string;
}

const LabelInsideSelectField: React.FC<SelectInputProps> = ({
  label,
  id,
  name,
  options,
  value,
  onChange,
  onBlur,
  touched,
  error,
  width = "w-100",
  showLabel = true,
  placeholder,
}) => {
  return (
    <div className={width}>
      {label !== null ? (
        <>
          <label htmlFor="">{label}</label>
        </>
      ) : null}
      <div
        className={
          touched[name]! && error[name]!
            ? "label-inside-input-error input-container-wrapper"
            : "label-inside-input input-container-wrapper"
        }
      >
        <Select
          id={id}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          className="input-control"
          options={options}
          placeholder={placeholder}
        />
        {touched[name] && error[name] && (
          <div className="error-line">
            <span>{error[name] as string}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LabelInsideSelectField;
